import { render, staticRenderFns } from "./CerradasFilterComponent.vue?vue&type=template&id=44947d41"
import script from "./CerradasFilterComponent.vue?vue&type=script&lang=js"
export * from "./CerradasFilterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports